// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Wallet3Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Wallet3/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 10.517v1.716c0 .467-.383.85-.858.85h-1.608c-.9 0-1.725-.658-1.8-1.558-.05-.525.15-1.017.5-1.358a1.66 1.66 0 0 1 1.2-.5h1.708c.475 0 .858.383.858.85Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.817 11.633a2.949 2.949 0 0 1 .875-2.358 2.902 2.902 0 0 1 2.075-.858h.475c.233 0 .425-.192.391-.425a3.34 3.34 0 0 0-3.3-2.867H5a3.332 3.332 0 0 0-3.333 3.333v5.834A3.332 3.332 0 0 0 5 17.625h8.333a3.334 3.334 0 0 0 3.3-2.867c.034-.233-.158-.425-.391-.425h-.375c-1.584 0-2.917-1.183-3.05-2.7Zm-1.984-1.716h-5a.624.624 0 1 1 0-1.25h5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625ZM11.842 3.317c.216.225.025.558-.292.558H5.025c-.908 0-1.758.267-2.467.725-.325.208-.766-.017-.608-.375a3.062 3.062 0 0 1 2.817-1.85H9.45c.967 0 1.825.342 2.392.942Z"
}));
export default Wallet3Icon;